import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import CallInfo from '../../component/CallInfo';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import AccountList from '../../component/Account/AccountList';
import Information from '../../component/Information';
import Main_Spring from '../../component/Spring/Main_Spring';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import ParentInfo from '../../component/Info/ParentInfo';
import musicTitle from '../../asset/music/jeongSik0921.mp3'
import PhotoBox1 from '../../component/PhotoBox1';

const YoonJeongSik = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "윤정식♥최미란 결혼합니다.";
    const openDesc = "9월 21일 오전 11시";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/275/thumb.jpg";

    const lng = 127.072550761301;
    const lat = 37.2535366049407;

    const placeTelNum = "031-202-3773";

    const forParking = "2시간 무료\n· 제 1주차장 : 트리플렉스 \n  (수원시 영통구 매영로 345번길 7)\n· 제 2주차장 : 영통공영주차장 \n  (수원시 영통구 봉영로 1598)";
    const forSubway = "수인분당선 영통역 8번출구 (도보 3분)"
    const forBus = "영통 랜드마크호텔 정류장 (공항버스) : 4100-1(공항)\n영통역 8번 출구 정류장\n시내버스 : 2-1,3,13-1,34-1,203,720-3\n1|842 : 1112,5100,7000,G5100.M5107";


    {/* const parents = [
        {groom : "김두희 · 이연숙의 장남"},
        {bride : "❁이석원 · 박영란의 차녀"}
    ] */}

    // const parentInfo = {
    //     groom: {
    //         dad: { name: "명남식", isDeceased: false },
    //         mom: { name: "안인순", isDeceased: true },
    //         role: "아들",
    //     },
    //     bride: {
    //         dad: { name: "이금하", isDeceased: false },
    //         mom: { name: "구은숙", isDeceased: false },
    //         role: "딸",
    //     }
    // };

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    // 블루A #9FB4E7
        // 연퍼플 #e4aced
    // 빈티지 연퍼플 #bf9cd8
    // 소라 : #88abd1
    // #edacb1
    // #D77599
    // #BC5078
    // #ff8faf
    // 레몬 옐로우 #EFD140
    // #EB9217
    // 빈티지 옐로우 : #EAC63C
    // #FC62A4
    // #f5408d
    // #ffb0d2 쿨 연핑크
    // 핑크A #FF8A83
    const conceptStyle = {
        // 핑크A
        concept: "SPRING",
        titleColor: "#FF8A83",
        pointColor: "#FF8A83",
        btnBgColor: "#FFE8E7",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fefaf9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const infoTitle = "우리 결혼합니다.";

    const msg1 = "2025년 09월 21일, \n저희 두 사람이 오랜 기다림 끝에 \n평생을 함께하며 같이 걸어가게 되었습니다.";
    const msg2 = "부디 저희의 결혼 소식이 \n여러분들의 마음에 불편함이 아닌 \n기쁜 소식이 되길 바라며 \n\n귀한 발걸음, 귀한 시간 내어주시어 \n저희의 앞날을 축하해 주신다면 \n그 마음 평생 잊지 않고 축복과 감사에 보답하며 \n바르게 살아가겠습니다."
    const msg3 = "저희 둘의 결혼을 축하해 주시는 \n모든 분들께 진심으로 감사합니다.\n예쁘게 잘 살겠습니다❤";
    const msg4 = "\n💌 일시 : 2025년 09월 21일 일요일 오전 11시 \n💌 장소 : 더 마레보 웨딩홀 15층\n\n\n"


    const groomAccountList = [
        {
            role: "신랑",
            name: "윤정식",
            bank: "기업은행",
            accountNumber : "607-001112-01-017",
            isKakao : false
        }
        ,{
            role: "신랑 부",
            name: "윤태일",
            bank: "국민은행",
            accountNumber : "534201-04-056527",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "김정화",
            bank: "기업은행",
            accountNumber : "607-000898-02-016",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "최미란",
            bank: "국민은행",
            accountNumber : "589201-04-039-155",
            isKakao : false
        }
        // ,{
        //     role: "신부 부",
        //     name: "최영운",
        //     bank: "농협은행",
        //     accountNumber : "351-0221-6137-53",
        //     isKakao : false
        // }
        // ,{
        //     role: "신부 모",
        //     name: "박내숙",
        //     bank: "신한은행",
        //     accountNumber : "705-06-059690",
        //     isKakao : false
        // }
    ]


    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이승욱",
            call: "010-2786-9838"
        }
        ,{
            role: "신랑 부",
            name: "이복수",
            call: "010-5335-6083"
        }
        ,{
            role: "신랑 모",
            name: "허혜란",
            call: "010-9567-9847"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "한서희",
            call: "010-5802-2401"
        }
        ,{
            role: "신부 부",
            name: "한송만",
            call: "010-9145-9317"
        },
        {
            role: "신부 모",
            name: "윤미영",
            call: "010-5530-9317"
        }
    ]

    const interviewContent = [
        {
            question : "서로의 첫인상 기억해?",
            groomAnswer: "4차원소녀🧝🏻‍♀️",
            brideAnswer: "동글왕감자🥔"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "긴장반설렘반",
            brideAnswer: "두근콩닥콩닥"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "옆자리내꺼♥️",
            brideAnswer: "알라뷰쏘마치"
        },
        {
            question : "부부가 된 기념 한마디!",
            groomAnswer: "즐기며살자",
            brideAnswer: "나만따라와"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "모든분들",
            brideAnswer: "행복만가득♥️"
        }
    ]

    const informationList =[
        {
            title : "포토부스 안내",
            content : "예식장 입구에 포토부스가 마련되어 있습니다.\n즐겁게 촬영해 주시고 \n즐거운 추억으로 간직해 주세요. \n\n추가로 2부 예식 시 포토 방명록 글 중,\n좋은 글귀 랜덤으로 선물 증정하고 있습니다 :) 많은 참여 부탁드립니다❤️"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#FF8A83"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring2 weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter title={infoTitle} msg1={msg1} msg2={msg2} msg3={msg3} msg4={msg4} conceptStyle={conceptStyle}/>
                    {/* <MotionWrapper initialY={70}>
                        <ParentInfo conceptStyle={conceptStyle} parentInfo={parentInfo} weddingData={weddingData}/>
                    </MotionWrapper> */}
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>    
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>    
                    <Information divHeight={"290px"} width={"320px"} pointFontColor={"#9b111e"} divMarginBottom={"50px"} divTopPadding={"0px"} conceptStyle={conceptStyle} informationList={informationList} />
                    <MotionWrapper initialY={50}>
                        {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>    
                    <Location_Desc forParking={forParking} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                    <PhotoBox1 photoUrl={"https://d39wt6wnedokd1.cloudfront.net/275/map1.jpeg"} imgwidth={"330px"}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default YoonJeongSik;